import { LeoUUID } from "@surya-digital/leo-ts-runtime";
import { RouteSearchParam } from "../../routes/RoutesHelper";

export const getValidatedLeoUUIDFromSearchParam = (
  searchParams: URLSearchParams,
  searchParamKey: RouteSearchParam,
): LeoUUID | null => {
  const templateIdString = searchParams.get(searchParamKey);
  if (!templateIdString) return null;

  try {
    return new LeoUUID(templateIdString);
  } catch (error) {
    return null;
  }
};
